<template>
  <my-dialog
    @hideMask="dialogFlagForLoading = false"
    :hideMaskFlag="maskFlag"
    :dialogFlag="dialogFlagForLoading"
    width="330px"
    p_lr="0"
    class="loading_create_dialog"
  >
    <div class="lc_box">
      <h3 v-show="percent < 100">课程创建中，请稍候...</h3>
      <h3 v-show="percent >= 100">课程创建完毕！</h3>
      <div class="tips" v-show="percent < 100">课程创建过程中请不要关闭此页面</div>
      <div class="tips" v-show="percent >= 100">创建成功：{{ successNum }}，创建失败：{{ failNum }}</div>
      <a-progress
        type="circle"
        :percent="percent"
        :format="(percentNum) => `${percentNum}%`"
      />
      <div
        class="confirm_btn ZHIHUISHU_QZMD"
        v-show="percent >= 100"
        @click="dialogFlagForLoading = false"
      >
        <a-button class="ZHIHUISHU_QZMD" type="primary" @click="closeModal">确认</a-button>
      </div>
    </div>
  </my-dialog>
</template>

<script>
export default {
  components: {
    'my-dialog': () => import('./my_dialog'),
  },
  props: {
    courseId: {
      default: () => '',
    },
    showModalProp: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    showModalProp(newVal, oldVal) {
      this.dialogFlagForLoading = newVal
      if (newVal) {
        this.loadingStart()
      }
    },
  },
  data() {
    return {
      dialogFlagForLoading: false,
      maskFlag: false,
      percent: 0,
      timer: 0,
      createStatus: 0,
      successNum: 0,
      failNum: 0
    }
  },
  created() {},
  methods: {
    loadingStart() {
      if (this.percent < 100 && this.courseId) {
        this.maskFlag = false
        clearInterval(this.timer)
        this.timer = setInterval(async () => {
          if (this.createStatus == 2) {
            clearInterval(this.timer)
            return
          }
          let courseId = typeof this.courseId == 'string' ? Number(this.courseId) : this.courseId
          let res = await this.$http.getCreatedLiveResult({
            courseId,
          })
          if (res.code !== 200) {
            this.$message.error(res.msg)
            return
          }
          if (res.rt.status == 2) {
            this.percent = 100
            this.createStatus = 2
            this.successNum = res.rt.successNum
            this.failNum = res.rt.failNum
            return
          }
          this.percent = (res.rt.successNum / res.rt.count * 100).toFixed(0) || 0
        }, 2000)
      } else {
        clearInterval(this.timer)
        this.maskFlag = true
      }
    },
    closeModal() {
      clearInterval(this.timer)
      this.percent = 0
      this.createStatus = 0
      this.successNum = 0
      this.failNum = 0
      this.$bus.emit('createCourseOk')
      this.$emit('update:showModalProp', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.loading_create_dialog {
 ::v-deep.show_box_son {
    display: flex;
    justify-content: center;
    align-items: center;
    .lc_box {
      padding: 30px 0 30px 0;
      text-align: center;
      h3 {
        margin-bottom: 15px;
      }
      .tips {
        margin-bottom: 30px;
        color: orange;
      }
      .confirm_btn {
        margin-top: 30px;
      }
    }
  }
}
</style>
